import { BaseGraphTransformer } from './BaseGraphTransformer';
import { PREDEFINED_ATTRIBS } from '../../view/my-store/components/constants';

// eslint-disable-next-line max-len
export class MarketplaceAttributionsGraphTransformer extends BaseGraphTransformer {
    constructor(params, title = '') {
        super(params);
        this.usedColors = [];
        this.title = title;
        this.monoChromeScaleFactory = this.monoChromeScaleFactoryGen();
    }

    getDefaultColor() {
        return '#CCCCCC';
    }

    getAffiliateColor() {
        return this.monoChromeScaleFactory.next().value;
    }

    *colorFactoryGen() {
        const colors = [
            '#003f5c',
            '#2f4b7c',
            '#665191',
            '#a05195',
            '#d45087',
            '#f95d6a',
            '#ff7c43',
            '#ffa600',
            '#ffcd42'
        ];
        let colorsCopy = [...colors];
        while (colorsCopy.length) {
            if (colorsCopy.length === 1) {
                yield colorsCopy.pop();
                colorsCopy = [...colors];
                continue;
            }
            yield colorsCopy.pop();
        }
    }

    *monoChromeScaleFactoryGen() {
        const colors = [
            '#003434',
            '#004d4d',
            '#006767',
            '#008080',
            '#009a9a',
            '#00b3b3',
            '#00cdcd'
        ];

        let colorsCopy = [...colors];
        while (colorsCopy.length) {
            if (colorsCopy.length === 1) {
                yield colorsCopy.pop();
                colorsCopy = [...colors];
                continue;
            }
            yield colorsCopy.pop();
        }
    }

    getBaseRowProps() {
        return {
            backgroundColor: 'transparent'
        };
    }

    isPredfinedChannelByName(name) {
        return Boolean(PREDEFINED_ATTRIBS.find(a => a.typeLabel === name));
    }

    getProps() {
        this.graphProps.chartType = 'bar';
        this.graphProps.options = {
            maintainAspectRatio: false,
            legend: {
                display: true,
                position: 'left'
            },
            title: {
                padding: 25,
                fontSize: 20,
                display: true,
                position: 'top',
                text: `${this.title} (Page Views)`
            },
            scales: {
                yAxes: [
                    {
                        stacked: true,
                        ticks: {
                            beginAtZero: true
                        }
                    }
                ],
                xAxes: [
                    {
                        stacked: true
                    }
                ]
            }
        };

        return this.graphProps;
    }

    transformData(data) {
        const dataSets = [];
        const colorFactory = this.colorFactoryGen();

        data.graph.rows.forEach(row => {
            const isCustom = !this.isPredfinedChannelByName(row.channel);
            const regColor =
                colorFactory.next().value || this.getDefaultColor();
            const bgColor = isCustom ? this.getAffiliateColor() : regColor;

            dataSets.push({
                backgroundColor: bgColor || this.getDefaultColor(),
                borderColor: '#FFFFFF',
                borderWidth: 0.5,
                borderSkipped: false,
                label: `${row.channel} – page views`,
                data: row.data,
                isCustom
            });
        });

        return {
            xValues: data.graph.dates,
            yValues: dataSets,
            graphProps: this.getProps()
        };
    }
}
